import React, { useState } from 'react';
import { Container, Row, Col, Navbar } from 'react-bootstrap';
import Sidebar from './components/Sidebar';
import SubwayMap from './components/SubwayMap';
import WorkflowCard from './components/WorkflowCard';
import MetricsPanel from './components/MetricsPanel';
import { workflows } from './mockData';
import './App.css';

function App() {
  const [selectedWorkflow, setSelectedWorkflow] = useState(workflows[0]);

  return (
    <div className="App">
      <Navbar bg="dark" variant="dark" className="mb-1">
        <Container fluid>
          <Navbar.Brand>
            <i className="bi bi-diagram-3 me-2"></i>
            ProcessFlow - Enterprise Workflow Analysis
          </Navbar.Brand>
        </Container>
      </Navbar>

      <Container fluid>
        <Row>
          <Col md={3} className="sidebar-col">
            <Sidebar
              workflows={workflows}
              selectedWorkflow={selectedWorkflow}
              onSelectWorkflow={setSelectedWorkflow}
            />
          </Col>
          <Col md={9} className="main-content">
            <div className="reference-section">
              <div className="content-section">
                <h2 className="mb-1" style={{fontSize: '1.5rem'}}>Reference Workflow: {selectedWorkflow.name}</h2>
                <SubwayMap
                  steps={selectedWorkflow.reference.steps}
                  connections={selectedWorkflow.reference.connections}
                  title="Standard Process Flow"
                  variant="reference"
                />
              </div>
            </div>

            <div className="variants-section">
              <div className="content-section">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <h2 style={{fontSize: '1.5rem'}}>Detected Workflow Variants</h2>
                  <span className="badge bg-danger">
                    {selectedWorkflow.detected.length} variants found
                  </span>
                </div>

                <MetricsPanel workflow={selectedWorkflow} />

                {selectedWorkflow.detected.map((workflow) => (
                  <WorkflowCard 
                    key={workflow.id} 
                    workflow={workflow} 
                    referenceWorkflow={selectedWorkflow.reference}
                  />
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;

